import React, { useState, useRef } from "react";
import commonStyles from "../../../Components/Shared/commonStyles.module.css";
import styles from "./ContactUs.module.css";
import CallToAction from "../../../Components/Shared/CallToAction/CallToAction";
import useContactStore from "../../../Stores/useContactStore";
import { Link } from "react-router-dom";
import * as fa from "react-icons/fa";
import { Turnstile } from "@marsidev/react-turnstile";
import ErrorLabel, { ErrorBody } from "../../../Components/Shared/Errors/ErrorLabel";
import Modal from "../../../Components/Shared/Modal/Modal";
import Spinner from "../../../Components/Shared/Spinner/Spinner";
import {getTurnstileSiteKey} from "../../../Helpers/ConfigProvider";

function ContactUs() {
  const [contactDetails, setContactDetails] = useState({
    Name: "",
    Email: "",
    Phone: "",
    Message: "",
    EmailMarketing: false,
  });

  const { contact, getContactDetails, sendContactForm,sendingMessage,errors } = useContactStore();

  const [showNumber, setShowNumber] = useState(false);
  const showNumberHandler = async () => {
    if (Object.keys(contact).length === 0) {
      await getContactDetails();
    }
    setShowNumber(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setContactDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleWhatsApp = () => {
    if (!contact?.PhoneNumber) {
      alert("Phone number not available.");
      return;
    }

    const phoneNumber = contact?.PhoneNumber; // Use the phone number from the contact details
    const message = ""; // Customize the message as needed
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
    setShowNumber(false); // Close the flip card after opening WhatsApp
  };


  const [showModal, setShowModal] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [hideSubmitButton, setHideSubmitButton] = useState(false);

  const turnstileSiteKey = getTurnstileSiteKey();
  const [token, setToken] = useState(null);
  const [pendingSubmit, setPendingSubmit] = useState(false);
  const turnstileRef = useRef(null);

  const handleTurnstileSuccess = (t) => {
    setToken(t);
    submitForm(t);
  };

  const submitForm = async (turnstileToken) => {
    setPendingSubmit(false);
    
    
    const response = await sendContactForm({ ...contactDetails, turnstileToken });
    if (response === false) {
      setFormSubmitted(false);
    }
    else {
      setFormSubmitted(true);
    }
    setHideSubmitButton(false);
    setShowModal(true);
    setToken(null);
    return response;
  };

  const handleSubmit = async (e) => {
    setHideSubmitButton(true);
    e.preventDefault();
    setPendingSubmit(true); // this mounts the Turnstile, which auto-runs
  };


  const hasErrors = (propertyName) => {

    if (errors && errors.length > 0) {
      return errors.some((error) => error.PropertyName === propertyName);
    }
    return false;
  };

  const getErrorMessages = (propertyName) => {
    if (errors && errors.length > 0) {
      const error = errors.find((error) => error.PropertyName === propertyName);
      return error ? error.ErrorMessages : [];
    }
    return [];
  };

  const closeModal = () => {
    setShowModal(false);
  }

  return (
    <div>
      {sendingMessage && (<Spinner />)}
      {showModal && (
        <Modal
          isOpen={showModal}
          onClose={closeModal}
          title={formSubmitted ? "Message Sent" : "Error"}
        >
          {formSubmitted ? (
            <p>Thank you for your message. We will get back to you shortly.</p>
          ) : (
            <p>There was an error sending your message. Please try again later.</p>
          )}
          <button className={commonStyles.btn} onClick={closeModal}>Close</button>
        </Modal>
      )}     
      <div className={`${commonStyles.section} `}>
        <div className={commonStyles.sectionHeaderContainer}>
          <h2 className={commonStyles.sectionHeader}>Contact Us</h2>
        </div>
        <div className={commonStyles.container}>
          <span className={`${commonStyles.eyebrow} ${styles.GetInTouchLabel}`}>
            Get in touch
          </span>
          <form
            className={`${commonStyles.card} ${styles.contactFormWrapper}`}
            onSubmit={handleSubmit}
          >
            <div className={styles.columns}>
              <div className={styles.formDetails}>
                <h3>Contact details</h3>
                <div className={styles.formGroup}>
                  <ErrorLabel
                    LabelName="Name"
                    labelFor="Name"
                    hasErrors={hasErrors("Name")}
                    errorMessages={getErrorMessages("Name")}
                    className=""
                  />                 
                  <input
                    type="text"
                    id="Name"
                    name="Name"
                    value={contactDetails.Name}
                    onChange={handleInputChange}
                    autoComplete="name"
                  />
                </div>
                <div className={`${styles.formGroup}  ${hasErrors("Email") ? styles.error : ""}`}>
                  
                  <ErrorLabel
                    LabelName="Email"
                    labelFor="Email"
                    hasErrors={hasErrors("Email")}
                    errorMessages={getErrorMessages("Email")}
                    className=""
                  />
                  <input
                    type="email"
                    id="Email"
                    name="Email"
                    value={contactDetails.Email}
                    onChange={handleInputChange}
                    autoComplete="email"
                  />
                </div>
                <div className={`${styles.formGroup} `}>
                  <ErrorLabel
                    LabelName="Phone"
                    labelFor="Phone"
                    hasErrors={hasErrors("Phone")}
                    errorMessages={getErrorMessages("Phone")}
                    className=""
                  />                  
                  <input
                    type="tel"
                    id="Phone"
                    name="Phone"
                    value={contactDetails.Phone}
                    onChange={handleInputChange}
                    autoComplete="tel"
                  />
                </div>
              </div>
              <div className={styles.MessageContainer}>
                <h3>Message/Question</h3>
                <div className={`${styles.formGroup} `}>
                  
                  <label className={`${styles.messageLabel} ${hasErrors("Message") ? styles.errorStar : ""}`} htmlFor="Message">
                    Include recipient, occasion, product, personalisation, and
                    delivery details if relevant.
                  </label>
                  <ErrorBody
                    hasErrors={hasErrors("Message")}
                    errorMessages={getErrorMessages("Message")}
                  />
                  <div className={styles.textareaWrapper}>
                    <textarea
                      id="Message"
                      name="Message"
                      value={contactDetails.Message}
                      onChange={handleInputChange}
                      className={styles.messageTextarea}
                      maxLength={800}
                    ></textarea>
                    <div className={styles.messageCount}>
                      {contactDetails.Message.length}/800
                    </div>
                  </div>
                </div>
                <div className={styles.formGroupCheckbox}>
                  <input
                    type="checkbox"
                    id="EmailMarketing"
                    name="EmailMarketing"
                    checked={contactDetails.EmailMarketing}
                    onChange={(e) =>
                      setContactDetails((prevDetails) => ({
                        ...prevDetails,
                        EmailMarketing: e.target.checked,
                      }))
                    }
                  />
                  Yes, I’d like to receive occasional updates and offers from
                  Match Hampers. Sign me up for email marketing.
                </div>
              </div>
            </div>
            {pendingSubmit && (
            <Turnstile
              siteKey={turnstileSiteKey}
              onSuccess={handleTurnstileSuccess}
              onExpire={() => setToken(null)}
              onError={() => setPendingSubmit(false)}
              ref={turnstileRef}
              // options={{
              //   appearance: "execute",
              // }}
              // options={{
              //   size: "compact", // Set the size to "invisible" for invisible CAPTCHA
              //   language: "en",
              // }}
            />
            )}
            {!hideSubmitButton && (
              <button
                type="submit"
                className={`${styles.submitButton} ${commonStyles.btn} ${commonStyles.btnPrimary}`}
              >
                Submit
              </button>
            )}
          </form>
        </div>
      </div>

      <div className={commonStyles.section}>
        <div className={commonStyles.container}>
          <div className={commonStyles.eyebrow}>Other ways to contact us</div>
          <h2 className={styles.GetInTouchLabel}>
            Get in touch, we're here to help
          </h2>

          <div className={`${commonStyles.cards4} ${styles.cards4}`}>
            <div className={`${commonStyles.card} ${styles.card}`}>
              <h3>Email</h3>
              <Link
                to="mailto:contact@matchhampers.com"
                target="_blank"
                className={styles.cardContent}
              >
                contact@matchhampers.com
              </Link>
            </div>
            <div className={`${styles.FlipCard} `}>
              <div
                className={`${styles.FlipCardInner} ${showNumber ? styles.isFlipped : ""}`}
              >
                <div
                  className={`${styles.FlipFace} ${styles.card} ${styles.FlipFront} ${styles.EventCard} ${commonStyles.card}`}
                >
                  <h3>Phone</h3>
                  <button
                    className={`${commonStyles.btn} ${commonStyles.btnPrimary}`}
                    onClick={showNumberHandler}
                  >
                    Show Number
                  </button>
                </div>

                <div
                  className={`${styles.FlipFace} ${styles.card} ${styles.FlipBack} ${commonStyles.card}`}
                >
                  <div
                    className={`${styles.PhoneNumber} ${styles.cardContent}`}
                  >
                    +{contact?.PhoneNumber}
                  </div>
                  <button
                    className={`${commonStyles.btn} ${commonStyles.btnPrimary}`}
                    onClick={handleWhatsApp}
                  >
                    Click to WhatsApp
                    <fa.FaWhatsapp className={styles.WhatsAppIcon} />
                  </button>
                </div>
              </div>
            </div>

            <div className={`${commonStyles.card} ${styles.card}`}>
              <h3>Socials</h3>
              <div className={`${styles.Socials} ${styles.cardContent}`}>
                <div className={styles.SocialItem}>
                  <fa.FaLinkedin className={styles.SocialIcon} />
                  <Link
                    to="https://www.linkedin.com/company/match-hampers/"
                    target="_blank"
                    className={styles.LinkedInLink}
                  >
                    matchhampers
                  </Link>
                </div>
                <div className={styles.SocialItem}>
                  <fa.FaInstagram className={styles.SocialIcon} />
                  <Link
                    to="https://www.instagram.com/MatchHampers/"
                    target="_blank"
                    className={styles.InstagramLink}
                  >
                    @matchhampers
                  </Link>
                </div>
                <div className={styles.SocialItem}>
                  <fa.FaFacebook className={styles.SocialIcon} />
                  <Link
                    to="https://www.facebook.com/MatchHampers/"
                    target="_blank"
                    className={styles.FacebookLink}
                  >
                    @matchhampers
                  </Link>
                </div>
              </div>
            </div>
            <div className={`${commonStyles.card} ${styles.card}`}>
              <h3>In-Person</h3>
              <div
                className={`${styles.InPerson} ${styles.cardContent} ${styles.popupCard}`}
              >
                <Link
                  to="/Customer-Services/Popups"
                  className={`${commonStyles.btn} ${commonStyles.btnPrimary} ${styles.popupButton}`}
                >
                  See Pop-ups
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CallToAction />
    </div>
  );
}

export default ContactUs;
